import React, { useEffect, useState } from 'react';
import {
    notification,
    Select,
    Skeleton,
    Typography,
} from 'antd';

import { useTranslation } from 'react-i18next';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import {Link, useHistory,useParams} from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import Text from 'antd/es/typography/Text';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';

// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

const { Option } = Select;

interface Props {
    location: any;
}

const { Title } = Typography;
export default function FrontendCourseStudent(props: Props) {
    const { t } = useTranslation();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
    return (
        <div className={'profile-wrapper container-fluid pl-0 pr-0'}>
            <AuthConsumer>
                {({ isAuth, updateUser, cartTime, cart, user }) => (
                    <>
                    <div className='d-md-flex'>
                        
                        <FrontendSidebar menuSelect={8} />
                        
                        <div className={'profile-tab-content-div pl-3 pr-3 mb-3'} style={{width: '100%'}}>
                        <div className='courseStudentSection'>
                            <StudentList />
                        </div>
                        </div>
                    </div>
                    </>
                )}
            </AuthConsumer>
        </div>
    );
}
function StudentList() {
    const { t } = useTranslation();
    const RouteParams:any = useParams();
    const [studentList, setStudentList] = useState([] as any[]);
    const [fetching, setFetching] = useState(false as boolean);
    useEffect(() => {
        let params:any;
        if(RouteParams['id']){
            params = { course_id : RouteParams['id']}
        }
        setFetching(true);
        API_SERVICE.getStudentList(params).then(({ data: { data: { items } } }) => {
            setStudentList(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#frontCourseStudentList').DataTable();
                // } ,1000);
            });
            setFetching(false);
        }).catch((e: any) => {
            setFetching(false);
            notification.error({ message: t(API_SERVICE.handleErrors(e)) });
        });
    }, [RouteParams['id']]);
    if(fetching){
        return <Skeleton active={true} />
    }
    return <div>
        <div className='bg-white p-3 br-5px mt-3'>
            <div className="row">
            <div className="col-md-12 pb-3">
                <div className="table-responsive table-br-5 box-shadow mt-2">
                    <table id='frontCourseStudentList' className="table  table-meetings table-report">
                    <thead>
                        <tr>
                            <th className="text-uppercase text-secondary">{t('genDict.name')}</th>
                            <th className="text-uppercase text-secondary">{t('genDict.courses')}</th>
                            {/* <th className="text-uppercase text-secondary text-center">{t('genDict.price')}</th> */}
                            <th className="text-uppercase text-secondary">{t('genDict.phone')}</th>
                            <th className="text-uppercase text-secondary">{t('genDict.email')}</th>
                            <th className="text-uppercase text-secondary text-center">{t('Completion Percentage')}</th>
                            {/* <th className="text-uppercase text-secondary">{t('genDict.payment_method')}</th> */}
                            <th className="text-uppercase text-secondary text-center">{t('Subscribed At')}</th>
                            <th className="text-uppercase text-secondary text-center">{t('Completed At')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                        studentList && studentList.map(students => {
                            console.log('students',students)
                            
                            if(students.order.user) {
                                return <tr>
                                <td>{students.order.user !== null && students.order.user.name !== '' ? students.order.user.name : ''}</td>
                                <td>{students.course.title}</td>
                                {/* <td>
                                    <span><Text type={'danger'} delete>${students.price}</Text> &nbsp;<Text
                                    strong>${students.sale_price}</Text></span></td> */}
                                <td>{students?.order?.user?.phone || ''}</td>
                                <td>{students?.order?.user?.email || ''}</td>
                                <td className=' text-center'>
                                    <div className="circle-small mt-4">
                                        <div className="text">{Math.round(students?.course?.completion_percentage)}%</div> 
                                        <svg>
                                            <circle className="bg" cx="40" cy="40" r="37"></circle>
                                            <circle className="progress two" cx="40" cy="40" r="37" style={{strokeDashoffset: -(((232 * students?.course?.completion_percentage)/100)-232)}}></circle>
                                        </svg>
                                    </div>
                                </td>
                                {/* <td>{students.order.payment_method || ''}</td> */}
                                <td className=' text-center'><span>{moment(new Date(students?.order?.created_at || '')).format('LLL')}</span></td>
                                <td className=' text-center'><span>{students?.course?.course_completion_detail?.completed_at ? moment(new Date(students?.course?.course_completion_detail?.completed_at || '')).format('LLL') : "-"}</span></td>
                            </tr>
                            }

                            
                        }) 
                    }
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
    </div>;
}
